import React, { useState, useEffect, useRef } from "react";

import DrawerComponent from "./DrawerComponent";

import CalendarIcon from "../../assets/calendar.svg";

import { Dropdown } from "react-bootstrap";
import newIcon from "../../assets/newIcn.png";
import { filters, filterRecords } from "./constants";
import AppointmentTableRow from "./AppointmentTableRow";
import AppointmentDateRangePicker from "./AppointmentDateRangePicker";
import moment from "moment";
import NoDataFound from "../../assets/Nodata.svg";
import RescheduleModal from "../DoctorDashboard/modal-reschedule";
import CancellationModal from "../DoctorDashboard/modal-cancellation";
import MarkNoShowModal from "../DoctorDashboard/modal-mark-noshow";
import CloseOngoingConsultModal from "../DoctorDashboard/modal-close-ongoing-consult";
import AppointmentScheduledModal from "../DoctorDashboard/modal-appointment-scheduled";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import { useHistory } from "react-router-dom";
import SelectedFilter from "./SelectedFilter";
import AppointmentJoinModal from "../DoctorDashboard/modal-appointment-join";
import MarkCheckInModal from "../DoctorDashboard/modal-mark-check-in";
import ShowMoreText from "react-show-more-text";
import Filter, { filterType } from "../common/filter";
import {
  LOCALSTORAGEKEY,
  removeFromLocal,
} from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

const AppointmentHistoryList = ({
  pastAppointmentData,
  viewAppointment,
  fetchPastAppointmentDataList,
  doctorsRelatedDataStatus,
  consultationStatus,
  currentStatus,
  fetchCurrentFilterDates,
  fetchCurrentFilterMarkCheckInDates,
  resetClick,
  slugUrl,
  children,
  term,
  mobileFilter,
  mobileFilterData,
  prescriptionFilter,
  selectedAppointmentType,
  resetMobileFilter,
  currentPage,
  fetchPastAppointmentDatasAgain,
  doctorFilterList,
  doctor_selected,
  setTempDoctorSelected,
  temp_doctor_selected,
}) => {
  let is_staff = localStorage.getItem("user_type");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerType, setDrawerType] = useState("");
  const [appointmentForDrawer, setAppointmentForDrawer] = useState({});
  const [show, setShow] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [markCheckinStartDate, setMarkCheckinStartDate] = useState("");
  const [markCheckinEndDate, setMarkCheckinEndDate] = useState("");
  const [allDoctorsRelatedData, setAllDoctorsRelatedData] = useState({
    name: "All",
    value: "all",
    doctor_id: temp_doctor_selected,
  });
  const [selectedDoctorsRelatedData, setSelectedDoctorsRelatedData] =
    useState();
  const [status, setStatus] = useState({
    name: "All",
    value: "all",
  });
  const [appointmentStatus, setAppointmentStatus] = useState({
    name: "All",
    value: "all",
  });
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [showCancellationModal, setShowCancellationModal] = useState(false);
  const [showRaiseInvoiceModal, setRaiseInvoiceModal] = useState(false);
  const [showMarkNoShowModal, setShowMarkNoShowModal] = useState(false);
  const [showCloseOngoingConsultModal, setShowCloseOngoingConsultModal] =
    useState(false);
  const [showAppointmentScheduledModal, setShowAppointmentScheduledModal] =
    useState(false);
  const [appointment, setAppointment] = useState();
  const [ongoingAppointment, setOngoingAppointment] = useState({});
  const [scheduledAppointment, setScheduledAppointment] = useState({});
  const [selectedConsultation, setSelectedConsultation] = useState();
  const [selectedAppointmentStatus, setSelectedAppointmentStatus] = useState();
  const [showJoinAppointmentModal, setShowJoinAppointmentModal] =
    useState(false);
  const scrollRef = useRef();
  const lines = 10; // these many lines will be completely visible and 10th will show "show more..."
  const [datePickerType, setdatePickerType] = useState("");

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  const openDatePicker = (type) => {
    setdatePickerType(type);
    setShow(!show);
  };
  let history = useHistory();

  useEffect(() => {
    scrollRef.current.scrollLeft = 0;
    scrollRef.current.scrollTo(0, 0);
  }, [pastAppointmentData]);

  let filterValues = filters?.appointmentStatus;
  if (
    selectedAppointmentType &&
    (selectedAppointmentType.value === "upcoming" ||
      selectedAppointmentType.value === "past")
  ) {
    filterValues = filters?.appointmentStatus?.filter((appointment) =>
      filterRecords(selectedAppointmentType.value, appointment.value)
    );
  }

  const handleDate = () => {
    setStartDate("");
    setEndDate("");
    localStorage.removeItem("appointmentStartDate");
    localStorage.removeItem("appointmentEndDate");
    fetchCurrentFilterDates("", "");
  };
  const handleMarkCheckinDate = () => {
    setMarkCheckinStartDate("");
    setMarkCheckinEndDate("");

    localStorage.removeItem("appointmentCheckInStartDate");
    localStorage.removeItem("appointmentCheckInEndDate");
    fetchCurrentFilterMarkCheckInDates("", "");
  };

  const handleConsultation = () => {
    setStatus({ label: "All", value: "all", doctor_id: temp_doctor_selected });
    setSelectedConsultation("");
    localStorage.setItem(
      "appointmentConsultationFilter",
      JSON.stringify({
        label: "All",
        value: "all",
        doctor_id: temp_doctor_selected,
      })
    );
    consultationStatus("", currentPage);
  };

  const handleAppointmentStatus = () => {
    setAppointmentStatus({
      label: "All",
      value: "all",
      doctor_id: temp_doctor_selected,
    });
    localStorage.setItem(
      "appointmentStatusFilter",
      JSON.stringify({
        label: "All",
        value: "all",
        doctor_id: temp_doctor_selected,
      })
    );
    setSelectedAppointmentStatus("");
    currentStatus("", currentPage);
  };

  const handleSelectedDoctorsRelatedData = () => {
    setAllDoctorsRelatedData({
      name: "All",
      value: "all",
      doctor_id: doctor_selected,
    });
    setSelectedDoctorsRelatedData("");
    removeFromLocal(LOCALSTORAGEKEY.appointmentDoctorName);

    doctorsRelatedDataStatus("");
  };
  const getDates = (start, end) => {
    setStartDate(moment(start).format("DD/MM/YYYY"));
    setEndDate(moment(end).format("DD/MM/YYYY"));
  };

  const getDatesForMarkCheckIn = (start, end) => {
    setMarkCheckinStartDate(moment(start).format("DD/MM/YYYY"));
    setMarkCheckinEndDate(moment(end).format("DD/MM/YYYY"));
  };

  function renderAppointmentType(appointmentType) {
    switch (appointmentType) {
      case "in-clinic":
        return <span>In-Clinic</span>;
      case "online":
        return <span>Online</span>;
      default:
        return "";
    }
  }

  const getAllProcedures = (allProcedures) => {
    let procedures = allProcedures?.replace(
      "in-clinic regular",
      "in-clinic regular (Paid - Online)"
    );
    return procedures?.replace(/,/g, ", ");
  };
  function renderConsultationType(
    appointmentType,
    consultationType,
    procedureName,
    allAppointmentProcedures,
    appointment_id,
    appointment_status,
    payment_method
  ) {
    let appointmentTypeText =
      appointmentType === "in-clinic" ? "In-Clinic" : "Tele-Consult";

    switch (appointmentType) {
      case "online":
        if (consultationType === "instant") {
          return <span>Instant</span>;
        }
        if (consultationType === "followup") {
          return <span>{appointmentTypeText + " Follow-Up"}</span>;
        }
        return appointmentTypeText + " Regular";
      case "regular":
        return <span>{appointmentTypeText + " Regular"}</span>;
      case "followup":
        return <span>{appointmentTypeText + " Follow-Up"}</span>;
      case "procedure":
        return <span>{procedureName}</span>;
      case "in-clinic":
        if (consultationType === "procedure") {
          return (
            <ShowMoreText
              /* Default options */
              lines={lines}
              more={<span style={{ color: "#17bae0" }}>Show more</span>}
              less="Show less"
              className="content-css"
              anchorClass="my-anchor-css-class"
              onClick={() => handleModal(appointment_id, appointment_status)}
              expanded={false}
              expandByClick={false}
              truncatedEndingComponent={"... "}
            >
              {allAppointmentProcedures !== ""
                ? allAppointmentProcedures?.replace(/,/g, ", ")
                : procedureName?.replace(/,/g, ", ")}
            </ShowMoreText>
          );
        }
        return (
          <ShowMoreText
            /* Default options */
            lines={lines}
            more={<span style={{ color: "#17bae0" }}>Show more</span>}
            less="Show less"
            className="content-css"
            anchorClass="my-anchor-css-class"
            onClick={() => handleModal(appointment_id)}
            expanded={false}
            expandByClick={false}
            truncatedEndingComponent={"... "}
          >
            {allAppointmentProcedures !== ""
              ? payment_method === "online"
                ? allAppointmentProcedures
                    .toLowerCase()
                    .includes("in-clinic regular")
                  ? getAllProcedures(allAppointmentProcedures)
                  : allAppointmentProcedures?.replace(/,/g, ", ")
                : allAppointmentProcedures?.replace(/,/g, ", ")
              : appointmentType +
                (payment_method === "online" ? " (Paid - Online)" : "") +
                " " +
                consultationType}

            {/* ,In-Clinic : Appendectomy, Cataract Surgery / Refractive Lens,
            Exchange, C-Section, CT Scan, Echocardiogram, Heart Bypass Surgery,
            Hip Replacement Surgery, MRI, Angioplasty and Atherectomy, Stent
            Procedure. */}
          </ShowMoreText>
        );
      case "instant":
        return <span>Instant</span>;
      default:
        return "";
    }
  }
  // <=

  function handleDrawerToggle() {
    setDrawerOpen(false);
    if (fetchPastAppointmentDatasAgain) {
      fetchPastAppointmentDatasAgain();
    }
  }

  function handleViewDocumentClick(selectedAppointment) {
    setAppointmentForDrawer({
      app_id: {
        id: selectedAppointment.appointment_id,
      },
      patientId: selectedAppointment.patient_id,
      patient_dob: selectedAppointment.patient_dob,
      patient_name: selectedAppointment.patient_name,
      patient_phone_no: selectedAppointment.patient_phone_no,
    });
    setDrawerOpen(true);
    setDrawerType("Documents"); //View Documents
  }

  function editPrescriptionAction(appointment) {
    let tempDate = new Date();
    let yr = tempDate.getFullYear();
    let age = yr - Number(appointment.patient_dob.substring(0, 4));

    setAppointmentForDrawer({
      app_id: {
        id: appointment.appointment_id,
        patient_gender: appointment.patient_gender,
      },
      ageForDrawer: age,
      patientId: appointment.patient_id,
      patientAccountId: appointment.patient_account_id,
      patient_dob: appointment.patient_dob,
      patient_name: appointment.patient_name,
      patient_phone_no: appointment.patient_phone_no,
      doctor_id: appointment.doctor_id,
    });

    setDrawerOpen(true);
    setDrawerType("Edit Prescription");
  }

  function rescheduleAppointmentAction(appointment) {
    setAppointment(appointment);
    setShowRescheduleModal(true);
  }

  function cancelAppointmentAction(appointment) {
    setAppointment(appointment);
    setShowCancellationModal(true);
  }

  function raiseInvoiceAction(appointment) {
    setAppointment(appointment);
    setRaiseInvoiceModal(true);
  }

  function markNoShowAction(appointment) {
    setAppointment(appointment);
    setShowMarkNoShowModal(true);
  }
  function handleJoinCallClick(appointment) {
    afterLoginApiAxios
      .post(
        "/doctor/check-for-appointment",
        { doctor_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (response.data) {
          if (response.data.statusCode === 200) {
            setAppointment(appointment);

            //Check for ongoing appointment
            if (
              response.data.ongoing_appointment &&
              response.data.data.appointment_id !== appointment.appointment_id
            ) {
              setOngoingAppointment(response.data.data);
              setShowCloseOngoingConsultModal(true);
            }
            // Check for upcoming scheduled appointment
            else if (response.data.upcoming_appointment) {
              setScheduledAppointment(response.data.data);
              setShowAppointmentScheduledModal(true);
            }
            // Join video call
            else {
              checkJoinAlert(appointment);
            }
          }
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  function checkJoinAlert(appointment) {
    afterLoginApiAxios
      .post(
        "/user/check-joining-alert",
        { meeting_id: appointment?.appointment_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (response.data) {
          if (response.data?.statusCode === 200) {
            if (
              response.data?.data?.show_pop_up &&
              appointment.meeting_status == "0"
            ) {
              setShowJoinAppointmentModal(true);
            } else {
              joinVideoCall(appointment);
            }
          } else {
            joinVideoCall(appointment);
          }
        } else {
          joinVideoCall(appointment);
        }
      })
      .catch((err) => C2CConsole.log(err));
  }
  function joinVideoCall(appointment) {
    history.push({
      pathname: "/doctor/video",
      state: {
        app_id: {
          // this is required as video component requires these properties
          id: appointment.appointment_id,
          patient_id: appointment.patient_id,
          patient_account_id: appointment.patient_account_id,
          patient_name: appointment.patient_name,
          patient_dob: appointment.patient_dob,
          phone_no: appointment.patient_phone_no,
          patient_city: appointment.patient_city,
          first_name: appointment.doctor_first_name,
          last_name: appointment.doctor_last_name,
          degree: appointment.degree,
          appointment_date: appointment.appointment_date,
          appointment_end_date_time: appointment.appointment_end_date_time,
          appointment_start_date_time: appointment.appointment_start_date_time,
          start_time: appointment.appointment_start_time,
          end_time: appointment.appointment_end_time,
          doctor_id: userId,
        },
        is_audio: true,
        is_video: true,
      },
    });
  }

  function getAllDoctorsRelatedData() {
    let data = JSON.parse(
      localStorage.getItem(LOCALSTORAGEKEY.appointmentDoctorName)
    );
    if (is_staff !== "staff") {
      data["doctor_id"] = userId;
    }
    setAllDoctorsRelatedData(data);
    setSelectedDoctorsRelatedData(data);
    doctorsRelatedDataStatus(data);
    setTempDoctorSelected(data.doctor_id);
  }

  function getStatus(data) {
    let appointmentConsultationFilter = JSON.parse(
      localStorage.getItem("appointmentConsultationFilter")
    );
    if (is_staff === "staff") {
      data["doctor_id"] = temp_doctor_selected;
    } else {
      data["doctor_id"] = userId;
    }
    setStatus(data);
    setSelectedConsultation(data);
    consultationStatus(appointmentConsultationFilter);
  }

  function getAppointmentStatus(data) {
    let appointmentStatusFilter = JSON.parse(
      localStorage.getItem("appointmentStatusFilter")
    );
    if (is_staff === "staff") {
      data["doctor_id"] = temp_doctor_selected;
    } else {
      data["doctor_id"] = userId;
    }
    setAppointmentStatus(data);
    setSelectedAppointmentStatus(data);
    currentStatus(appointmentStatusFilter);
  }

  const resetFilter = () => {
    setStatus({ value: "all", label: "All" });
    setStartDate("");
    setEndDate("");
    setMarkCheckinStartDate("");
    setMarkCheckinEndDate("");
    setSelectedAppointmentStatus("");
    setSelectedConsultation("");
    setAppointmentStatus({ value: "all", label: "All" });
    if (is_staff === "staff") {
      setAllDoctorsRelatedData({
        name: "All",
        value: "all",
        doctor_id: doctor_selected,
      });
    } else {
      setAllDoctorsRelatedData({
        name: "All",
        value: "all",
        doctor_id: userId,
      });
    }
    setSelectedDoctorsRelatedData("");
    localStorage.setItem(
      "appointmentStatusFilter",
      JSON.stringify({ value: "all", label: "All" })
    );
    localStorage.setItem(
      "appointmentConsultationFilter",
      JSON.stringify({ value: "all", label: "All" })
    );
    localStorage.removeItem("appointmentStartDate");
    localStorage.removeItem("appointmentEndDate");
    localStorage.removeItem("appointmentCheckInStartDate");
    localStorage.removeItem("appointmentCheckInEndDate");
    localStorage.removeItem("appointment_status_filter");
    localStorage.removeItem("appointmentPrescriptionFilter");
    localStorage.removeItem("appointmentDoctorName");
    resetClick();
  };
  const refreshAppointments = () => {
    setStatus("");
    setStartDate("");
    setEndDate("");
    setSelectedAppointmentStatus("");
    setSelectedConsultation("");
    setAppointmentStatus("");
    fetchPastAppointmentDataList();
  };

  const handleModal = (appointment_id, appointment_status) => {
    viewAppointment(appointment_id, appointment_status);
  };

  return (
    <div className=" mt-3 bg-grey">
      <div
        className={` ${pastAppointmentData.length === 0 && "disable-scroll"} `} //cont-width-main table-scroll-style
        ref={scrollRef}
        id="appointment"
      >
        <div className="cont-width-main-body-appointment-history">
          <div className="patient-row-header transaction-row-header align-items-center my-2 mx-0  p-2 text-uppercase d-md-flex">
            <div className="created_at mt-2">
              <div style={{ display: "flex", alignItems: "center" }}>
                <div>
                  APPOINTMENT <br />
                  DATE & TIME
                </div>
                <img
                  className="appointment-calendar-icon"
                  src={CalendarIcon}
                  onClick={() => openDatePicker("date&time")}
                  alt="cal"
                />
              </div>
            </div>

            <div className="mark_checkin_date_time mt-2">
              <div style={{ display: "flex", alignItems: "center" }}>
                <div>
                  MARK CHECK-IN <br />
                  DATE & TIME
                </div>
                <img
                  className="appointment-calendar-icon"
                  src={CalendarIcon}
                  onClick={() => openDatePicker("markcheckin")}
                  alt="cal"
                />
              </div>
            </div>
            <div className="mark_checkin_by mt-2">MARK CHECK-IN BY</div>
            {/* <div className="patient_name mt-2">Patient Name</div> */}
            {is_staff === "staff" ? (
              <div className="d-flex patient_name mt-2">
                <p className="appointment-table-status-col">Doctor Name</p>
                <Dropdown size="sm">
                  <Dropdown.Toggle
                    id="dropdownMenu2"
                    className="appointment-dropdown-toggle"
                  >
                    <img
                      className="appointment-calendar-icon"
                      src={newIcon}
                      alt=""
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="appointment-table-dropdown-menu">
                    {doctorFilterList?.map((item, index) => (
                      <Dropdown.Item
                        onClick={() => {
                          localStorage.setItem(
                            LOCALSTORAGEKEY.appointmentDoctorName,
                            JSON.stringify(item)
                          );
                          getAllDoctorsRelatedData();
                        }}
                        className="appointment-dropdown-item d-flex text-label"
                        key={index}
                      >
                        <i
                          className={`fa fa-check mr-3 check-icon-filter ${
                            allDoctorsRelatedData.value === item.value
                              ? "activeTab"
                              : ""
                          }`}
                          aria-hidden="true"
                        ></i>
                        {item.name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            ) : (
              ""
            )}

            <div className="patient_phone_no mt-2">Mobile Number</div>
            <div className=" d-flex status mt-2">
              <p className="appointment-table-status-col">Consultation</p>
              <Filter
                type={filterType.CONSULTATION}
                handleFilter={(item) => {
                  localStorage.setItem(
                    "appointmentConsultationFilter",
                    JSON.stringify(item)
                  );
                  getStatus(item);
                }}
                temp_doctor_selected={temp_doctor_selected}
                selectedValue={status}
              />
            </div>
            <div className={`d-flex status mt-2 `}>
              <p className="appointment-table-status-col">Appointment Status</p>
              <Dropdown size="sm">
                <Dropdown.Toggle
                  id="dropdownMenu2"
                  className="appointment-dropdown-toggle"
                >
                  <img className="appointment-calendar-icon" src={newIcon} />
                </Dropdown.Toggle>

                <Dropdown.Menu className="appointment-table-dropdown-menu dropdown-scroll_style">
                  {filterValues.map((item, index) => (
                    <Dropdown.Item
                      onClick={() => {
                        localStorage.setItem(
                          "appointmentStatusFilter",
                          JSON.stringify(item)
                        );
                        getAppointmentStatus(item);
                      }}
                      className="appointment-dropdown-item d-flex text-label"
                      key={index}
                    >
                      <i
                        className={`fa fa-check mr-3 check-icon-filter ${
                          appointmentStatus.value == item.value
                            ? "activeTab"
                            : ""
                        }`}
                        aria-hidden="true"
                      ></i>
                      {item.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              {/* <Filter type={filterType.APPOINTMENTSTATUS} /> */}
            </div>
            {/* <div className="action_type mt-2">Action</div> */}
          </div>
        </div>
        <SelectedFilter
          start={startDate}
          end={endDate}
          markCheckInStartDate={markCheckinStartDate}
          markCheckinEndDate={markCheckinEndDate}
          selectedDoctorsRelated={selectedDoctorsRelatedData}
          selectedConsultation={selectedConsultation}
          selectedAppointmentStatus={selectedAppointmentStatus}
          handleDate={handleDate}
          handleMarkCheckinDate={handleMarkCheckinDate}
          status={status}
          handleConsultation={handleConsultation}
          resetFilter={resetFilter}
          appointmentStatus={appointmentStatus}
          handleAppointmentStatus={handleAppointmentStatus}
          handleSelectedDoctorsRelatedData={handleSelectedDoctorsRelatedData}
          term={term}
          mobileFilter={mobileFilter}
          mobileFilterData={mobileFilterData}
          prescriptionFilter={prescriptionFilter}
          resetMobileFilter={resetMobileFilter}
        />
        {pastAppointmentData && pastAppointmentData.length > 0 ? (
          <div className="mt-2">
            {pastAppointmentData.map((element, index) => (
              <AppointmentTableRow
                appointmentData={element}
                index={index}
                key={element.appointment_id}
                renderAppointmentType={renderAppointmentType}
                renderConsultationType={renderConsultationType}
                handleViewDocumentClick={handleViewDocumentClick}
                viewAppointment={viewAppointment}
                editPrescriptionAction={editPrescriptionAction}
                rescheduleAppointmentAction={rescheduleAppointmentAction}
                cancelAppointmentAction={cancelAppointmentAction}
                raiseInvoiceAction={raiseInvoiceAction}
                markNoShowAction={markNoShowAction}
                handleJoinCallClick={handleJoinCallClick}
                currentPage={currentPage}
                allDoctorsRelatedData={allDoctorsRelatedData}
              />
            ))}
          </div>
        ) : (
          <div
            className="text-center d-flex flex-column justify-content-center bg-white"
            style={{ height: 400 }}
          >
            <div className="">
              <img src={NoDataFound} />
            </div>
            <div style={{ marginTop: 15 }}>
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: 15,
                  color: "#1B2027",
                  textAlign: "center",
                }}
              >
                No Record Found
              </span>
            </div>
            <span
              style={{ fontSize: 12, color: "#707070", textAlign: "center" }}
            >
              There are no appointments available
            </span>
          </div>
        )}
        {show && (
          <AppointmentDateRangePicker
            fetchDates={(start, end) => {
              if (datePickerType === "date&time") {
                fetchCurrentFilterDates(start, end);
                getDates(start, end);
              } else {
                getDatesForMarkCheckIn(start, end);
                fetchCurrentFilterMarkCheckInDates(start, end);
              }
            }}
            class_name={
              datePickerType === "date&time"
                ? "date_picker_position"
                : "mark_check_date_picker_position"
            }
            datePickerType={datePickerType}
            closeDatePicker={openDatePicker}
          />
        )}
        {children}
      </div>
      <DrawerComponent
        drawerOpen={drawerOpen}
        toggleDrawer={handleDrawerToggle}
        drawerType={drawerType}
        appointmentForDrawer={appointmentForDrawer}
        fetchPastAppointmentDataList={fetchPastAppointmentDataList}
      />
      <AppointmentJoinModal
        appointment={appointment}
        openView={showJoinAppointmentModal}
        closeView={() => {
          setShowJoinAppointmentModal(false);
        }}
        joinVideoCallback={() => joinVideoCall(appointment)}
      />
      <RescheduleModal
        appointment={appointment}
        doctor_id={appointment?.doctor_id}
        openView={showRescheduleModal}
        closeView={() => {
          setShowRescheduleModal(false);
        }}
        slugUrl={slugUrl}
        refreshAppointmentsMethod={refreshAppointments}
      />
      <CancellationModal
        appointment_id={appointment?.appointment_id}
        doctorId={appointment?.doctor_id}
        openView={showCancellationModal}
        closeView={() => {
          setShowCancellationModal(false);
        }}
        refreshAppointmentsMethod={refreshAppointments}
        fetchUpcomingAppointments={() => {}}
      />
      <MarkCheckInModal
        appointment_id={appointment?.appointment_id}
        edit_receipt={appointment?.edit_receipt}
        openView={showRaiseInvoiceModal}
        closeView={() => {
          setRaiseInvoiceModal(false);
        }}
        refreshAppointmentsMethod={refreshAppointments}
        doctor_id={appointment?.doctor_id}
      />
      <MarkNoShowModal
        appointment_id={appointment?.appointment_id}
        openView={showMarkNoShowModal}
        closeView={() => {
          setShowMarkNoShowModal(false);
        }}
        refreshAppointmentsMethod={refreshAppointments}
        doctor_id={appointment?.doctor_id}
      />
      <CloseOngoingConsultModal
        appointment_id={ongoingAppointment.appointment_id}
        patient_name={ongoingAppointment.patient_name}
        consultation={renderConsultationType(
          ongoingAppointment.appointment_type,
          ongoingAppointment.consultation_type,
          ongoingAppointment.procedure_name,
          ongoingAppointment.appointment_status
        )}
        openView={showCloseOngoingConsultModal}
        closeView={() => {
          setShowCloseOngoingConsultModal(false);
        }}
        refreshAppointmentsMethod={refreshAppointments}
        joinVideoCallback={() => joinVideoCall(appointment)}
      />
      <AppointmentScheduledModal
        appointment_id={scheduledAppointment.appointment_id}
        patient_name={scheduledAppointment.patient_name}
        appointment_start_time={scheduledAppointment.appointment_start_time}
        appointment_end_time={scheduledAppointment.appointment_end_time}
        openView={showAppointmentScheduledModal}
        closeView={() => {
          setShowAppointmentScheduledModal(false);
        }}
        refreshAppointmentsMethod={refreshAppointments}
        joinVideoCallback={() => joinVideoCall(appointment)}
      />
    </div>
  );
};

export default AppointmentHistoryList;
